import gql from 'graphql-tag'

export const GET_BRAND_LOCATION_FRAGMENT = gql`
   fragment BrandLocationFrag on brands_brand_location {
      id
      brandId
      location {
         id
         locationAddress
         label
         zipcode
         city
         state
         lat
         lng
         country
      }
   }
`
